var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPSliderRightGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.313,
    height: 13.313,
    viewBox: "0 0 13.313 13.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5495",
    "data-name": "Group 5495",
    transform: "translate(1155.854 508.763) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M-1171.648,461.562l8-8",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M-1169.087,453.562h6.132",
    transform: "translate(-0.693)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M0,0H6.132",
    transform: "translate(-1163.648 453.562) rotate(90)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPSliderRightGray);
export default __webpack_public_path__ + "static/media/p-slider-right-gray.77d479396a4efd08bac0df9067fccefc.svg";
export { ForwardRef as ReactComponent };